import urlUtil from 'scripts/utils/url';
import _ from 'lodash';

export default {
    trackPageLoad(pageName) {
        if(typeof(_satellite) != 'undefined'){
            setPageDigitalData(pageName);
            _satellite.pageBottom();
        }
    },
    trackGSRSVideoSection(section) {
        if(typeof(_satellite) != 'undefined' && section){
            setGSRSSection(section);
            _satellite.track('gsrs-video-section-set');
        }
    },
    trackKbygOpen(moduleName) {
        if(typeof(_satellite) != 'undefined'){
            setKbygDigitalData(moduleName);
            _satellite.track('kbyg');
        }
    },
    trackTrendingBoxLoad() {
        if(typeof(_satellite) != 'undefined'){
            setTrandingDigitalData();
            _satellite.track('trendingBoxLoads');
        }
    },
    trackAmexLoad() {
        if(typeof(_satellite) != 'undefined'){
            setAmexDigitalData();
            _satellite.track('amexLoads');
        }
    },
    trackRoadToUsoDigitalData(playerName) {
        if(typeof(_satellite) != 'undefined'){
            setRoadToUsoDigitalData(playerName);
            _satellite.track('road-to-uso');
        }
    },
    trackVideoLaunch(videoName, videoSourceLocation) {
        if(typeof(_satellite) != 'undefined'){
            setVideoLaunchDigitalData(videoName, videoSourceLocation);
            _satellite.track('video-launch');
        }
    },
    trackVideoFilter(filterName) {
        if(typeof(_satellite) != 'undefined') {
            setVideoFilterDigitalData(filterName);
            _satellite.track('vod-filter');
        }
    },
    trackScatterPlot(element) {
        if(typeof(_satellite) != 'undefined') {
            setScatterPlotDigitalData(element);
            _satellite.track('scatter-plot');
        }
    },
    trackShots(playerId) {
        if(typeof(_satellite) != 'undefined') {
            setShotsDigitalData(playerId);
            _satellite.track('shot-by-shot');
        }
    },
    trackTeeTimesTab(tab, tabData) {
        if(typeof(_satellite) != 'undefined') {
            setTabDigitalData(tab, tabData);
            _satellite.track('tee-times-tab');
        }
    },
    trackPlayerStatsTab(tab, tabData) {
        if(typeof(_satellite) != 'undefined') {
            setTabDigitalData(tab, tabData);
            _satellite.track('player-stats-tab');
        }
    },
    trackPlayerDetailTab(tab, tabData) {
        if(typeof(_satellite) != 'undefined') {
            setTabDigitalData(tab, tabData);
            _satellite.track('player-detail-tab');
        }
    },
    trackInternationalBroadcast() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('ibf-search');
        }
    },
    trackLeaderboardFavoriting(playerName) {
        if(typeof(_satellite) != 'undefined') {
            setLeaderboardFavoritingDigitalData(playerName);
            _satellite.track('favoriting-player');
        }
    },
    trackLeaderboardExpand(playerName) {
        if(typeof(_satellite) != 'undefined') {
            setLeaderboardExpandDigitalData(playerName);
            _satellite.track('lbd-expand');
        }
    },
    trackPollSubmission() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('poll-submission');
        }
    },
    trackTeeTimesCalendar() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('calendar-icon');
        }
    },
    trackPipChannelSwap() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('pip-channel-swap');
        }
    },
    trackPipGoFullScreen() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('go-full-screen');
        }
    },
    trackPipInteraction() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('pip-interaction');
        }
    },
    /* USGA */
    trackVideoTopicalSwimLineClick(swimLineName, swimLanePosition) {
        if(typeof(_satellite) != 'undefined') {
            setVideoTopicalSwimLineDigitalData(swimLineName, swimLanePosition);
            _satellite.track('video-topical-swim-lane-click');
        }
    },
    trackFooterPartnerClick(partnerName) {
        if(typeof(_satellite) != 'undefined') {
            setFooterPartnerName(partnerName);
            _satellite.track('footer-partner-click');
        }
    },
    trackFooterSocialMediaClick(socialName) {
        if(typeof(_satellite) != 'undefined') {
            setFooterSocialMediaName(socialName);
            _satellite.track('footer-follow-us-click');
        }
    },
    trackFooterNavNameClick(navName) {
        if(typeof(_satellite) != 'undefined') {
            setFooterNavName(navName);
            _satellite.track('footer-nav-click');
        }
    },
    trackFooterAppDownloadClick(appName) {
        if(typeof(_satellite) != 'undefined') {
            setFooterAppDownloadName(appName);
            _satellite.track('footer-app-download');
        }
    },
    trackDeparmentResoureLinkClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setDeparmentResoureLinkPosition(position);
            _satellite.track('department-landing-resource-click');
        }
    },
    trackDeparmentCardCarouselLinkClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setDeparmentCardCarouselPosition(position);
            _satellite.track('department-landing-card-carousel-click');
        }
    },
    trackShare(network) {
        if(typeof(_satellite) != 'undefined') {
            setShareType(network);
            _satellite.track('share');
        }
    },
    trackDeparmentContentCarouselCardClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setDeparmentContentCarouselCardPosition(position);
            _satellite.track('department-landing-content-carousel-card-click');
        }
    },
    trackTimelineTabClick(tabName) {
        if(typeof(_satellite) != 'undefined') {
            setTimelineTabClick(tabName);
            _satellite.track('timeline-tab-click');
        }
    },
    trackTimelineLoadMore() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('timeline-load-more-click');
        }
    },
    trackTimelineExternalLinkClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('timeline-social-card-external-link-click');
        }
    },
    trackTimelineVideoStart() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('timeline-video-play-click');
        }
    },
    trackTimelineVideoComplete() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('timeline-video-complete');
        }
    },
    trackDeparmentContentCarouselVideoStart() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('department-landing-content-carousel-video-start');
        }
    },
    trackDeparmentContentCarouselVideoComplete() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('department-landing-content-carousel-video-complete');
        }
    },
    trackHeroCarouselSlideClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setHeroCarouselSlidePosition(position);
            _satellite.track('hero-carousel-slide-click');
        }
    },
    trackHeroCarouselNavClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setHeroCarouselNavPosition(position);
            _satellite.track('hero-carousel-nav-click');
        }
    },
    trackWhatWeDoForGoldLinkClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setWhatWeDoForGoldLinkPosition(position);
            _satellite.track('what-we-do-for-golf-click');
        }
    },
    trackUsgaQuickHitsLinkClick(position) {
        if(typeof(_satellite) != 'undefined') {
            setUsgaQuickHitsLinkPosition(position);
            _satellite.track('usga-quick-hits-link-click');
        }
    },
    trackGlobalNavigationProfileIconClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('global-navigation-profile-click');
        }
    },
    trackGlobalNavigationSearchIconClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('global-navigation-search-icon-click');
        }
    },
    trackGlobalNavigationSearchForTerms(term) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationSearchForTerms(term);
            _satellite.track('global-navigation-searched-for-terms');
        }
    },
    trackGlobalNavigationSimpleLinkClick(linkText) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationSimpleLinkText(linkText);
            _satellite.track('global-navigation-simple-link-click');
        }
    },
    trackPromoImageClick(imageUrl) {
        if(typeof(_satellite) != 'undefined') {
            setPromoImageUrl(imageUrl);
            _satellite.track('promo-click');
        }
    },
    trackGlobalNavigationFeatureClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('global-navigation-feature-click');
        }
    },
    trackGlobalNavigationPromoClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('global-navigation-promo-click');
        }
    },
    trackVideoDetailAutoPlay() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('video-detail-autoplay');
        }
    },
    trackVideoDetailVideoComplete(imageUrl) {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('video-detail-video-complete');
        }
    },
    trackChampionshipsEventHeroVideoStart(imageUrl) {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('championships-event-hero-video-start');
        }
    },
    trackChampionshipsEventHeroVideoClose(imageUrl) {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('championships-event-hero-video-close');
        }
    },
    trackChampionshipsTabClick(tabName, tabLayout) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsTabNameAndLayout(tabName, tabLayout);
            _satellite.track('championships-tab-click');
        }
    },
    trackChampionshipsScoringSearchIconClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('championships-scoring-search-icon-click');
        }
    },
    trackChampionshipsRoundClick(roundName) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsRoundName(roundName);
            _satellite.track('championships-round-click');
        }
    },
    trackChampionshipsScoringScorecardRoundClick(roundName) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsScoringScorecardRoundName(roundName);
            _satellite.track('championships-scoring-scorecard-round-click');
        }
    },
    trackChampionshipsScoringSwitcherClick(switcherName) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsScoringSwitcherName(switcherName);
            _satellite.track('championships-scoring-switcher-click');
        }
    },
    trackChampionshipsTeeTimesSearchIconClick() {
        if(typeof(_satellite) != 'undefined') {
            _satellite.track('championships-tee-times-search-icon-click');
        }
    },
    trackChampionshipsTeeTimesConverterToggle(converterName) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsTeeTimesConverterName(converterName);
            _satellite.track('championships-tee-times-converter-toggle');
        }
    },
    trackRightRailLinkToFullClick(moduleName) {
        if(typeof(_satellite) != 'undefined') {
            setRightRailModuleName(moduleName);
            _satellite.track('right-rail-link-to-full-click');
        }
    },
    trackRightRailDropdownSelection(moduleName) {
        if(typeof(_satellite) != 'undefined') {
            setRightRailModuleName(moduleName);
            _satellite.track('right-rail-dropdown-selection');
        }
    },
    trackChampionshipsPlayerStatisticsToggle(toggleName) {
        if(typeof(_satellite) != 'undefined') {
            setChampionshipsPlayerStatisticsToggle(toggleName);
            _satellite.track('championships-player-statistics-toggle-click');
        }
    },
    trackGlobalNavigationTickerChampionshipSelectorClick(championshipName) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationTickerChampionship(championshipName);
            _satellite.track('global-navigation-ticker-championship-selector-click');
        }
    },
    trackGlobalNavigationTickerChampionshipWatchClick(championshipName) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationTickerChampionship(championshipName);
            _satellite.track('global-navigation-ticker-championship-watch-click');
        }
    },
    trackGlobalNavigationTickerChampionshipScoringClick(championshipName) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationTickerChampionship(championshipName);
            _satellite.track('global-navigation-ticker-championship-scoring-click');
        }
    },
    trackGlobalNavigationLinkClick(layout, column, navigationPosition, linkName, linkPosition) {
        if(typeof(_satellite) != 'undefined') {
            setGlobalNavigationClickedLinkInformation(layout, column, navigationPosition, linkName, linkPosition);
            _satellite.track('global-navigation-link-click');
        }
    },
    /* USGA */
    /* History experience */
    trackHistoryContentView(cardTitle, cardType, year, tag) {
        if(typeof(_satellite) != 'undefined') {
            setHistoryContentView(cardTitle, cardType, year, tag);
            _satellite.track('history-timeline-content-view');
        }
    },
    trackHistoryVideoLaunch(videoName, videoLocation) {
        if(typeof(_satellite) != 'undefined') {
            setHistoryTimelineVideoLaunch(videoName, videoLocation);
            _satellite.track('history-video-launch');
        }
    },
    trackSearchByPlayerCourse(name) {
        if(typeof(_satellite) != 'undefined') {
            setPlayerCourseName(name);
            _satellite.track('search-by-player-course');
        }
    },
    trackHistoryTimelineCollectionSelection(tagName) {
        if(typeof(_satellite) != 'undefined') {
            setHistoryTimelineCollectionTag(tagName);
            _satellite.track('history-timeline-collection-selection');
        }
    },
    trackHistoryTimelineYearSelection(year) {
        if(typeof(_satellite) != 'undefined') {
            setHistoryTimelineYear(year);
            _satellite.track('history-timeline-tag-selection');
        }
    },
    trackHistoryTimelineTagSelection(tag) {
        if(typeof(_satellite) != 'undefined') {
            setHistoryTimelineTag(tag);
            _satellite.track('history-timeline-tag-selection');
        }
    },
    trackPickemGameClick(title) {
        if(typeof(_satellite) != 'undefined') {
            setPickemGameTitle(title);
            _satellite.track('pickem-game-click');
        }
    },
}

function setVideoLaunchDigitalData(videoName, videoSourceLocation) {
    window.digitalData = {
        videoName: videoName,
        videoSourceLocation: videoSourceLocation
    }
}

function setRoadToUsoDigitalData(playerName) {
    window.digitalData = {
        playerName: playerName
    }
}

function setTabDigitalData(tab, tabData) {
    window.digitalData = window.digitalData || {};

    window.digitalData[tab] = tabData;
}

function setAmexDigitalData() {
    window.digitalData = {
        page: {
            pageInfo: {
                amexAlertLoad: 'true'
            }
        }
    }
}

function setTrandingDigitalData() {
    window.digitalData = {
        page: {
            pageInfo: {
                trendingBoxLoads: 'true'
            }
        }
    }
}

function setPageDigitalData(pageName) {
    let pageInfo = {
        PageName: pageName,
        Platform: 'Website'
    };

    urlUtil.getPathName()
        .replace(/.html/g, '')
        .split('/')
        .filter((part) => !!part)
        .slice(-3)
        .forEach((part, index) => pageInfo['SiteSectionL'+(index+1)] = part )
    ;

    if (window.digitalData && window.digitalData.page && window.digitalData.page.pageInfo) {
        window.digitalData.page.pageInfo = _.assign(window.digitalData.page.pageInfo, pageInfo);
    } else {
        window.digitalData = _.assign(window.digitalData || {}, {
            page: {
                pageInfo
            }
        });
    }
}

function setGSRSSection(gsrsSection) {
    _.merge(window.digitalData, {
        gsrsSection,
    });
}

function setKbygDigitalData(moduleName) {
    window.digitalData = {
        kbygModule: moduleName
    }
}

function setVideoFilterDigitalData(filterName) {
    window.digitalData = {
        vodFilter: filterName
    }
}

function setScatterPlotDigitalData(element) {
    window.digitalData = {
        scatterPlot: element
    }
}

function setShotsDigitalData(playerId) {
    window.digitalData = {
        playerName: playerId
    }
}

function setLeaderboardFavoritingDigitalData(playerName) {
    window.digitalData = {
        playerName: playerName
    }
}

function setLeaderboardExpandDigitalData(playerName) {
    window.digitalData = {
        playerName: playerName
    }
}

function setVideoTopicalSwimLineDigitalData(swimLineName, swimLanePosition) {
    _.merge(window.digitalData, {
        videoTopicalSwimLaneName: swimLineName,
        videoTopicalSwimLanePosition: swimLanePosition
    });
}

function setFooterPartnerName(partnerName) {
    _.merge(window.digitalData, {
        footerPartnerName: partnerName
    });
}

function setFooterSocialMediaName(socialName) {
    _.merge(window.digitalData, {
        footerFollowUsName: socialName
    });
}

function setFooterNavName(navName) {
    _.merge(window.digitalData, {
        footerNavName: navName
    });
}

function setFooterAppDownloadName(appName) {
    _.merge(window.digitalData, {
        footerAppDownloadPositionAndName: appName
    });
}

function setDeparmentResoureLinkPosition(position) {
    _.merge(window.digitalData, {
        departmentResourceLinkPosition: position
    });
}

function setDeparmentCardCarouselPosition(position) {
    _.merge(window.digitalData, {
        departmentCardCarouselPosition: position
    });
}

function setShareType(network) {
    _.merge(window.digitalData, {
        shareType: network
    });
}

function setDeparmentContentCarouselCardPosition(position) {
    _.merge(window.digitalData, {
        departmentContentCarouselCardPosition: position
    });
}

function setTimelineTabClick(tabName) {
    _.merge(window.digitalData, {
        timelineTabName: tabName
    });
}

function setHeroCarouselSlidePosition(position) {
    _.merge(window.digitalData, {
        heroCarouselSlidePosition: position
    });
}

function setHeroCarouselNavPosition(position) {
    _.merge(window.digitalData, {
        heroCarouselNavPosition: position
    });
}

function setWhatWeDoForGoldLinkPosition(position) {
    _.merge(window.digitalData, {
        whatWeDoForGolfLinkPosition: position
    });
}

function setUsgaQuickHitsLinkPosition(position) {
    _.merge(window.digitalData, {
        usgaQuickHitsLinkPosition: position
    });
}

function setGlobalNavigationSearchForTerms(term) {
    _.merge(window.digitalData, {
        globalNavigationSearchedTerm: term
    });
}

function setGlobalNavigationSimpleLinkText(linkText) {
    _.merge(window.digitalData, {
        globalNavigationSimpleLinkName: linkText
    });
}

function setPromoImageUrl(imageUrl) {
    _.merge(window.digitalData, {
        promoImageUrl: imageUrl
    });
}

function setChampionshipsTabNameAndLayout(tabName, tabLayout) {
    _.merge(window.digitalData, {
        championshipsTabName: tabName,
        championshipsTabLayout: tabLayout
    });
}

function setChampionshipsRoundName(roundName) {
    _.merge(window.digitalData, {
        championshipsRoundName: roundName
    });
}

function setChampionshipsScoringScorecardRoundName(roundName) {
    _.merge(window.digitalData, {
        championshipsScoringScorecardRoundName: roundName
    });
}

function setChampionshipsScoringSwitcherName(switcherName) {
    _.merge(window.digitalData, {
        championshipsScoringSwitcherName: switcherName
    });
}

function setChampionshipsTeeTimesConverterName(converterName) {
    _.merge(window.digitalData, {
        championshipsTeeTimesConverterName: converterName
    });
}

function setRightRailModuleName(moduleName) {
    _.merge(window.digitalData, {
        rightRailModuleName: moduleName
    });
}

function setChampionshipsPlayerStatisticsToggle(toggleName) {
    _.merge(window.digitalData, {
        championshipsPlayerStatisticsToggleName: toggleName
    });
}

function setGlobalNavigationTickerChampionship(championshipName) {
    _.merge(window.digitalData, {
        globalNavigationTickerSelectedChampionship: championshipName
    });
}

function setGlobalNavigationClickedLinkInformation(layout, column, navigationPosition, linkName, linkPoistion) {
    _.merge(window.digitalData, {
        globalNavigationLayout: layout,
        globalNavigationColumn: column,
        globalNavigationDepthLevel: navigationPosition,
        globalNavigationSimpleLinkName: linkName,
        globalNavigationLinkPosition: linkPoistion
    });
}

function setHistoryContentView(cardTitle, cardType, year, tag) {
    _.merge(window.digitalData, {
        historyTimelineCardTitle: cardTitle,
        historyTimelineCardType: cardType,
        historyTimelineCollectionYear: year,
        historyTimelineCollectionTag: tag
    });
}

function setHistoryTimelineVideoLaunch(videoName, videoLocation) {
    _.merge(window.digitalData, {
        videoName: videoName,
        videoSourceLocation: videoLocation
    });
}

function setPlayerCourseName(name) {
    _.merge(window.digitalData, {
        searchPlayerCourseName: name,
    });
}

function setHistoryTimelineCollectionTag(tagName) {
    _.merge(window.digitalData, {
        historyTimelineCollectionTag: tagName
    });
}

function setHistoryTimelineYear(year) {
    _.merge(window.digitalData, {
        historyTimelineCollectionYear: year
    });
}

function setHistoryTimelineTag(tag) {
    _.merge(window.digitalData, {
        historyTimelineCollectionTag: tag
    });
}

function setPickemGameTitle(pickemGameTitle) {
    _.merge(window.digitalData, {
        pickemGameTitle,
    });
}